<template>
  <div class="step step-one rvr-leaflet-map" v-if="placesLoaded && placeSizesLoaded">
      <h4>{{ texts.select_one_or_more_free_places }}</h4>
      <MapLegend :colors="colorList"/>
      <LeafletMapPublic />
    <p class="meta">{{ texts.disclaimer }}</p>
  </div>
  <div class="rvr-loading" v-if="!placesLoaded">

  </div>
</template>

<script>

import {onMounted, ref, watch} from "vue";

import LeafletMapPublic from "@/components/public/map/LeafletMapPublic.vue";
import MapLegend from "@/components/shared/MapLegend.vue";

import usePlaceSizes from "@/composables/usePlaceSizes";
import useReservations from "@/composables/useReservations";
import useTimeExpired from "@/composables/useTimeExpired";
import useStepNavigation from "@/composables/useStepNavigation";
import usePlaces from "@/composables/usePlaces";
import useTexts from "@/composables/useTexts";

export default {
  name: 'PublicStepOne',
  components: {
    MapLegend,
    LeafletMapPublic,
  },
  setup() {
    const { placeSizes, fetchPlaceSizes, placeSizesLoading, placeSizesLoaded } = usePlaceSizes();
    const {fetchPlaces, placesLoading, placesLoaded} = usePlaces();
    const { nrOfReservations } = useReservations();
    const { showExpiredMessage } = useTimeExpired();
    const { curStep, nextButtonEnabled, nextButtonText, nextButtonPressed, goToNextStep } = useStepNavigation();
    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent('PublicStepOne');
    curStep.value = 1;

    const colorList = ref([]);

    const showReservationCanceledMessage = false;

    //If the number of reservations goes from 0 to 1 we can reset the show expired message boolean
    //And enable / disable the next button
    watch( nrOfReservations, (newVal, oldVal) => {
      nextButtonEnabled.value = newVal > 0;
      if(newVal && !oldVal) {
        showExpiredMessage.value = false;
      }
    });

    watch(nextButtonPressed, (isPressed) => {
      if (isPressed) {
        nextButtonPressed.value = false;
        goToNextStep();
      }
    });

    onMounted(async () => {
      await fetchPlaceSizes();
      await fetchPlaces();

      colorList.value = placeSizes.value
          // Map the response to match colorList structure
          .map(place => ({size: `${place.size} m`, hex: place.color_code}))
          // Sort the array by size
          .sort((a, b) => {
            let [a1, a2] = a.size.split('x').map(Number);
            let [b1, b2] = b.size.split('x').map(Number);
            if (a1 !== b1) {
              return a1 - b1;
            } else {
              return a2 - b2;
            }
          })
          .concat(
              { size: t.value.not_free, hex: '#898989' },
              { size: t.value.option, hex: '#C0C0C0' },
              { size: t.value.reserved, hex: '#40A070' }
          );

        nextButtonEnabled.value = nrOfReservations.value > 0;
        nextButtonText.value = t.value.next_step;
    });

    return {
      colorList,
      nrOfReservations,
      showReservationCanceledMessage,
      placeSizesLoading,
      placesLoading,
      placesLoaded,
      placeSizesLoaded,
      nextButtonPressed,
      texts: t
    };
  },
};
</script>

<style scoped>
h4 {text-align: left;}
.step {background: #e9e9e9; padding: 20px; border-radius: 4px;}
.rvr-loading {
  width: 100%;
  height: 50vh;
  background-color: #e9e9e9
}
.meta {
  font-style: italic;
  padding-top: 5px;
}
</style>
